function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultCardStyle = {
  borderRadius: 'l',
  shadow: 500,
  backgroundColor: 'neutral.white',
  transition: 'outline-color 0.2s, box-shadow 0.2s, background-color 0.2s',
  outline: '2px solid',
  outlineColor: 'transparent',
  padding: 'm'
};

var getActionDefaultCardStyles = onClick => {
  if (!onClick) return {};
  return {
    border: 'selection.transparent',
    _hover: {
      shadow: '600'
    },
    _focusVisible: {
      outlineWidth: '2px',
      outlineOffset: '2px',
      outlineColor: 'focus.focus'
    },
    _selected: {
      border: 'selection.selectedBrand'
    }
  };
};

var getActionFlatCardStyles = onClick => {
  if (!onClick) return;
  return {
    cursor: 'pointer',
    _hover: {
      shadow: 0,
      borderColor: 'neutral.darkest',
      backgroundColor: 'neutral.lightest'
    },
    _focusVisible: {
      shadow: 0,
      outlineWidth: '2px',
      outlineOffset: '4px',
      outlineColor: 'focus.focus'
    },
    _selected: {
      shadow: 0,
      borderWidth: '2px',
      borderColor: 'brand.main'
    }
  };
};

var getDefaultLayerStyles = onClick => onClick ? getActionDefaultCardStyles(onClick) : defaultCardStyle;

export var cardTheme = {
  baseStyle: _ref => {
    var {
      onClick,
      paddingX,
      paddingY,
      width
    } = _ref;
    return _objectSpread(_objectSpread({}, getDefaultLayerStyles(onClick)), {}, {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      paddingY,
      paddingX,
      width,
      overflow: 'hidden',
      transition: 'outline-color 0.2s, box-shadow 0.2s, background-color 0.2s, border-color 0.1s ease-in-out'
    });
  },
  variants: {
    default: _ref2 => {
      var {
        paddingX,
        paddingY,
        width
      } = _ref2;
      return {
        borderRadius: 'l',
        shadow: 500,
        backgroundColor: 'neutral.white',
        outline: '2px solid',
        outlineColor: 'transparent',
        '&[data-inactive="true"]': {
          cursor: 'default',
          opacity: 0.5,
          shadow: 500,
          paddingX,
          paddingY,
          width
        },
        _disabled: {
          '&:not([data-inactive="true"])': {
            cursor: 'not-allowed',
            outlineColor: 'neutral.light',
            shadow: 0,
            paddingX,
            paddingY,
            width
          }
        }
      };
    },
    flat: _ref3 => {
      var {
        onClick,
        paddingX,
        paddingY,
        width
      } = _ref3;
      return _objectSpread(_objectSpread({
        borderRadius: 'l',
        border: 'basic.light',
        shadow: 0,
        backgroundColor: 'neutral.white'
      }, getActionFlatCardStyles(onClick)), {}, {
        '&[data-inactive="true"]': {
          shadow: 0,
          justifyContent: 'center',
          cursor: 'default',
          pointerEvents: 'none',
          backgroundColor: 'neutral.white',
          opacity: 0.5,
          outlineColor: 'neutral.light',
          outlineWidth: 1
        },
        _disabled: {
          _hover: {
            border: 'basic.light'
          },
          shadow: 0,
          outlineWidth: '1px',
          outlineColor: 'neutral.light',
          cursor: 'not-allowed',
          backgroundColor: 'neutral.white',
          paddingX,
          paddingY,
          width
        }
      });
    }
  },
  defaultProps: {
    paddingX: 'm',
    paddingY: 'm',
    width: 'full',
    variant: 'default'
  }
};
//# sourceMappingURL=Card.theme.js.map